import * as yup from 'yup';

export const addressProjectSchema = yup.object().shape({
    project_name: yup.string().required('Project Name is required'),
    country_id: yup.string().required('Country is required field'),
    province_id: yup.string().required('Province is required field'),
    regency_id: yup.string().required('Regency is required field'),
    subdistrict_id: yup.string().required('Subdisrict is required field'),
    village_id: yup.string().required('Village is required field'),
    address: yup.string().required('Address is required field'),
    note: yup.string().nullable(),
});